import anime from 'animejs';

export function subtitleInit(el) {
  const ctx = el instanceof HTMLElement ? el : el.node;

  anime.set(ctx, { translateY: -50, opacity: 0 });
}

export function subtitleAnim(el, delay = 0) {
  const ctx = el instanceof HTMLElement ? el : el.node;
  const tween = anime({
    targets: ctx,
    translateY: 0,
    opacity: 1,
    duration: 1500,
    easing: 'easeOutCirc',
    delay,
  });

  return tween;
}
